export interface NavigationItem {
  label: string;
  to?: string;
  href?: string;
  external?: boolean;
  onClick?: () => void;
  children?: NavigationItem[];
}

export enum ExpandedDesktopItem {
  None = 'none',
  Products = 'products', 
  About = 'about'
}

export const SPECIAL_PATHS = {
  application: ["/app", "/application", "/prequal", "/finish"],
  specialPages: ["/credit-builder", "/community-loans"],
} as const;

export const ABOUT_ITEMS: NavigationItem[] = [
  { label: "Our Texas Story", to: "/about/fig-texas-story" },
  { label: "Lending Model", to: "/about/responsible-lending-model" },
  { label: "Credit Reporting", to: "/loan-information/credit-reporting" },
  { label: "Compare Us", to: "/loan-information/compare-payday-loans" },
];

export const PRODUCT_ITEMS: NavigationItem[] = [
  { label: "Personal Loan", to: "/what-is-fig" },
  { label: "Credit Builder", to: "/credit-builder" },
];

export const getNavigationItems = (
  loggedIn: boolean, 
  handleSignOut?: () => void
): NavigationItem[] => [
  ...(loggedIn
    ? [
        { label: "My Account", to: "/me" },
        { label: "Help", to: "/help" },
      ]
    : [
        {
          label: "Help Center",
          href: "https://support.figloans.com/hc/en-us",
          external: true,
        },
      ]),
  { label: "Blog", to: "/blog" },
  ...(loggedIn
    ? [{ label: "Sign Out", onClick: handleSignOut }]
    : [{ label: "Sign In", to: "/signin" }]),
];